import { CateringCategoryQuery } from 'components/pages/CateringPage/types/CateringCategoryQuery'
import Faq from 'components/Faq'
import sortBy from 'lodash/sortBy'

type Props = {
  category: NonNullable<CateringCategoryQuery['cateringCategory']>
}

const FaqSection = ({ category }: Props) => {
  return (
    <div>
      <Faq
        className="bg-gray-50"
        faqs={sortBy(category.faqSections, 'position').map((s) => ({
          // eslint-disable-next-line react/no-danger
          answer: <div dangerouslySetInnerHTML={{ __html: s.content.html }} />,
          question: s.title
        }))}
        title={`Food Truck ${category.mainPage ? '' : `${category.name} `}FAQ`}
      />
    </div>
  )
}

export default FaqSection
